
import ModalLayout from '@/layouts/ModalLayout.vue';
import { defineComponent, ref, watch } from 'vue';
import useRequest from '@/composables/useRequest';
import { CreateTeamRequest } from '@/data/requests/CreateTeamRequest';
import { popModal, pushModal } from 'jenesius-vue-modal';
import ButtonElement from '@/components/ButtonElement.vue';
import InputElement from '@/components/InputElement.vue';
import { useI18n } from 'vue-i18n';
import TeamModal from '@/modals/TeamModal.vue';

export default defineComponent({
  props: {
    refreshHomePage: {
      type: Function,
      required: true,
    },
  },

  emits: ['onCreateTeam'],

  setup(props, { emit }) {
    const { t } = useI18n();

    const teamName = ref('');
    const loading = ref<boolean>();
    const error = ref<string[] | undefined>(undefined);
    const isCreateButtonDisabled = ref<boolean>(false);

    const doCreateTeam = async () => {
      loading.value = true;
      error.value = undefined;

      if (teamName.value.length > 30) {
        loading.value = false;
        error.value = [];
        error.value?.push(t('errors.team.max_length'));
      } else {
        var regex = new RegExp('^[A-Za-z0-9]*$');

        if (regex.test(teamName.value)) {
          const { execute } = useRequest<CreateTeamRequest, unknown>(new CreateTeamRequest(teamName.value), '');

          execute()
            .then(async () => {
              await emit('onCreateTeam');
              loading.value = false;
              popModal().then(() => {
                pushModal(TeamModal, {
                  editTeam: false,
                  refreshHomePage: props.refreshHomePage,
                  teamName: teamName.value,
                });
              });
            })
            .catch(() => {
              loading.value = false;

              error.value = [];
              error.value?.push(t('errors.team.name_taken'));
            });
        } else {
          loading.value = false;
          error.value = [];
          error.value?.push(t('errors.team.invalid_characters'));
        }
      }
    };

    watch(teamName, (newTeamName: string) => {
      const length = newTeamName?.length ?? 0;

      isCreateButtonDisabled.value = length <= 3;
    });

    return {
      doCreateTeam,
      loading,
      error,
      teamName,
      isCreateButtonDisabled,
    };
  },

  components: {
    InputElement,
    ModalLayout,
    ButtonElement,
  },
});
